import moment from "moment";
import { DATE_FORMATS } from "../../constants";

export const utcToDatePicker = (utcDate) => {
  return moment(utcDate, DATE_FORMATS.UTC).format(
    DATE_FORMATS.DATE_PICKER_FORMAT
  );
};
